// Language Selector JS

(function nSpainLanguageSelector($, Drupal) {
  Drupal.behaviors.nSpainLanguageSelect = {
    attach(context) {
      $(document).ready(function() {
        // Function to update the short language code
        function updateShortLanguageCode(selectedLanguage) {
          var shortLanguageCode = '';
          
          if(selectedLanguage === 'en') {
            shortLanguageCode = selectedLanguage;
          } else if(selectedLanguage === 'es') {
            shortLanguageCode = selectedLanguage;
          }
          
          $('#shortLanguageCode .lang-code').text(shortLanguageCode);
        }
        
        // Call the function on page load to initialize the short language code
        updateShortLanguageCode($('.primary-header .lang-dropdown-select-element').val());
        
        // Call the function when the language selector dropdown changes
        $('.primary-header .lang-dropdown-select-element', context).on('change', function() {
          var selectedLanguage = $(this).val();
          updateShortLanguageCode(selectedLanguage);
        });
      });
    },
  };
  
})(jQuery, Drupal);
